module.exports = __webpack_public_path__ + "img/print_light_ic.a11f4b28.png";